// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import {
  CreateUpdateTimeRecord,
  TimeRecordResponse,
  timeRecordResponseSchema,
} from '@/costs/api/types';
import { serializeOptionalCurrencyForAPI } from '@/currency/utilities/serialize';
import { serializeDateForAPI } from '@/utilities/date-time';

/**
 * Creates a new time record using the time record endpoint.
 *
 * @param params - The time record creation parameters
 */
export async function createTimeRecord(
  params: CreateUpdateTimeRecord
): Promise<TimeRecordResponse> {
  const url = '/v1/time-record';
  const response = await api.post(url, {
    ...params,
    incurredOn: serializeDateForAPI(params.incurredOn),
    hourlyRate: serializeOptionalCurrencyForAPI(params.hourlyRate),
  });

  return parseResponse(timeRecordResponseSchema, response.data, {
    schemaName: 'CreateTimeRecord',
    endpoint: url,
  });
}
